export enum Directions {
	right,
	left,
}
